<div class="dropdown d-inline-block">
  <a class="link" href="javascript:void(0)">
    <i class="fa fa-globe"></i> {{currentLanguage}}
  </a>
  <ul class="droplist">
    <li *ngFor="let lang of translate.getLangs()" (click)="changeLang(lang)"><a href="#">{{lang}}</a></li>
  </ul>
</div>
